var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.1472,
    y1: 180.6509,
    x2: 338.8528,
    y2: 358.3565,
    gradientTransform: "matrix(1 0 0 -1 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4860ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6E4DF6"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250,291.8c47.6-9.5,79.3-49.6,79.3-98.8c0-43.8-35.5-79.3-79.3-79.3s-79.3,35.5-79.3,79.3 C170.7,242.2,202.4,282.3,250,291.8z M349.1,193c0,56.2-35.5,103.6-89.6,117l4.8,9.7c1.2,2.5,0.2,5.4-2.2,6.7 c-2.5,1.2-5.4,0.2-6.7-2.2l-0.2-0.3c0.1,1.9,0.4,3.8,0.7,5.7c1.1,5.4,3.2,9.7,8.3,19.9c5.7,11.5,4.7,22.8,1.5,32.3 c-3.1,9.3-8.4,17.2-11.7,22.1l-0.1,0.1c-1.5,2.3-4.6,2.9-6.9,1.4c-2.3-1.5-2.9-4.6-1.4-6.9l0,0l0,0c3.3-5,7.9-11.9,10.6-19.9 c2.6-7.9,3.2-16.3-1-24.7l-0.3-0.6c-4.8-9.5-7.5-15-8.9-21.8c-0.6-2.9-0.9-5.9-1-8.9l-0.8,1.6c-1.2,2.5-4.2,3.5-6.6,2.3 c-2.5-1.2-3.5-4.2-2.3-6.6c0,0,0,0,0,0l0-0.1l4.8-9.7c-54.1-13.4-89.6-60.8-89.6-117c0-54.8,44.4-99.1,99.1-99.1 S349.1,138.2,349.1,193z M211.6,183.2c3.6-14,14.6-25,28.6-28.6c5.3-1.3,9.8-5.7,9.8-11.1c0-5.5-4.5-10-9.9-9.1 c-25,4.2-44.6,23.8-48.8,48.8c-0.9,5.4,3.6,9.9,9.1,9.9C205.9,193,210.2,188.5,211.6,183.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLight);
export default __webpack_public_path__ + "static/media/icon_light.e5c606a69c9fef3ece0b4704c0a86797.svg";
export { ForwardRef as ReactComponent };